import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../../services/Auth';

class CalendarsApi extends Api {
  constructor() {
    super('admin/calendars/');
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/admin/calendars.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  getFilters(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const props = params?.props || {};
    return axios({
      url: `${apiUrl}/calendars/filters`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: params.responseType, // important
      ...props,
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  importExcel(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      'import_create',
    );
  }
}

export default CalendarsApi;
